import blank from "./blank.svg";
import female_young_black from "./female_young_black.svg";
import female_young_white from "./female_young_white.svg";
import female_middle_black from "./female_middle_black.svg";
import female_middle_white from "./female_middle_white.svg";
import female_old_black from "./female_old_black.svg";
import female_old_white from "./female_old_white.svg";
import male_young_black from "./male_young_black.svg";
import male_young_white from "./male_young_white.svg";
import male_middle_black from "./male_middle_black.svg";
import male_middle_white from "./male_middle_white.svg";
import male_old_white from "./male_old_white.svg";
import male_old_black from "./male_old_black.svg";

const avatars = {
  blank,
  female_young_black,
  female_young_white,
  female_middle_black,
  female_middle_white,
  female_old_black,
  female_old_white,
  male_young_black,
  male_young_white,
  male_middle_black,
  male_middle_white,
  male_old_white,
  male_old_black,
};
export default avatars;
